import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { FooterComponent } from 'app/components/footer/footer.component';
import { HeaderComponent } from 'app/components/header/header.component';
import { InsuranceCardComponent } from './components/insurance-card/insurance-card.component';
import { MatIconModule } from '@angular/material/icon';
import { InsuranceService } from './insurance.service';
import { InsurancePopupComponent } from './components/insurance-popup/insurance-popup.component';
import { Router } from '@angular/router';
import { InsuranceBenefitsComponent } from './components/insurance-benefits/insurance-benefits.component';
import { environment } from 'environments/environment';

@Component({
    selector: 'app-insurance',
    templateUrl: './insurance.component.html',
    styleUrls: ['./insurance.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FooterComponent,
        HeaderComponent,
        TranslateModule,
        MatIconModule,
        InsuranceCardComponent,
        InsuranceBenefitsComponent,
    ],
})
export class InsuranceComponent implements OnInit {
    selectedLanguage: any;
    clickedOutside: boolean = false;
    allProducts: any = [];
    filteredProducts: any = [];
    displayedProducts: any = [];
    selectedProduct: any = {};
    imgs: any = {};
    sProd: string = '';
    showAllProducts: boolean = false;
    insurances: any[] = [];
    currentIndex = 0;
    visibleCount: number = 6; // default for desktop
    increment: number = 6; // how many to add on "Show More"
    isMobile: boolean = false;

    constructor(
        public dialog: MatDialog,
        private _insuranceService: InsuranceService,
        private _router: Router,
    ) {}

    ngOnInit(): void {
        this.selectedLanguage = localStorage.getItem('language');
        this._insuranceService.getInsuranceData().subscribe((data) => {
            this.allProducts = data;
            this.insurances = Object.keys(data).map((key) => ({
                key,
                img: data[key][0]?.img,
            }));
            this.filteredProducts = [...this.allProducts.Policystreet];
            this.sortByOrderNo(this.filteredProducts);
            this.imgs = {
                policystreet: data.Policystreet[0]?.img,
            };
            this.updateDisplayedProducts();
            this.setVisibleCount();
        });

        // Optional: Update on window resize
        window.addEventListener('resize', () => this.setVisibleCount());

        // window.addEventListener('resize', () => this.updateDisplayedProducts());
    }

    setVisibleCount() {
        const width = window.innerWidth;
        if (this.visibleCount <= 7) {
            if (width < 1028) {
                // iPad Mini / iPad Air / Mobile
                if (width < 576) {
                    this.visibleCount = 2;
                    this.increment = 2;
                } else {
                    this.visibleCount =
                        this.filteredProducts.length || this.allProducts.length;
                    this.increment = 3;
                }
            } else {
                // Desktop & iPad Pro
                this.visibleCount =
                    this.filteredProducts.length || this.allProducts.length;
                this.increment = 6;
            }
        }
    }

    showMore(): void {
        this.visibleCount += this.increment;
    }

    switchedLanguage(data: any) {
        this.selectedLanguage = data;
    }

    updateDisplayedProducts() {
        const isMobile = window.innerWidth <= 768;
        if (isMobile && !this.showAllProducts) {
            this.displayedProducts = this.filteredProducts.slice(0, 2);
        } else {
            this.displayedProducts = [...this.filteredProducts];
        }
    }

    filterProducts(key: string) {
        if (this.sProd === key) {
            this.sProd = null;
            this.filteredProducts = [...this.allProducts.Policystreet];
        } else {
            this.sProd = key;
            this.filteredProducts = this.allProducts[key];
        }
        this.sortByOrderNo(this.filteredProducts);
        this.showAllProducts = false;
        // this.updateDisplayedProducts();
        this.setVisibleCount();
    }

    toggleShowAllProducts() {
        this.showAllProducts = !this.showAllProducts;
        this.updateDisplayedProducts();
    }

    applyProduct(product: any) {
        this.selectedProduct = product;

        if (product.prodCode === 'INS00012') {
            this._router.navigate([
                '/insurance/policy-street/employee-benefits',
            ]);
        } else if (product.prodCode === 'INS00013') {
            this._router.navigate(['/insurance/policy-street/sme']);
        } else {
            this.openDialog();
        }
    }

    sortByOrderNo(arr) {
        this.filteredProducts = arr.sort((a, b) => a.orderno - b.orderno);
    }

    openDialog() {
        const isMobile = window.innerWidth <= 768;
        this.dialog.open(InsurancePopupComponent, {
            width: isMobile ? '100%' : '650px',
            maxWidth: isMobile && '95vw',
            height: isMobile ? '95%' : '620px',
            panelClass: 'insurance-popup',
            data: this.selectedProduct,
        });
    }

    changeMenuCondition(event: any) {
        this.clickedOutside = false;
    }

    closeMegaMenuCondition() {
        this.clickedOutside = !this.clickedOutside;
    }

    nextSlide() {
        const length = this.insurances.length;
        this.currentIndex = (this.currentIndex + 1) % length;
    }

    prevSlide() {
        const length = this.insurances.length;
        this.currentIndex = (this.currentIndex - 1 + length) % length;
    }
}
